import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export type MsalStatus = 'guest' | 'authed'

type MsalAuthState = {
    status: MsalStatus
    accountCount: number
    setFromAccountCount: (count: number) => void
    setAuthed: () => void
    setGuest: () => void
}

export const useMsalAuthStore = create<MsalAuthState>()(
    subscribeWithSelector((set) => ({
        status: 'guest',
        accountCount: 0,
        setFromAccountCount: (count) =>
            set({
                accountCount: count,
                status: count > 0 ? 'authed' : 'guest',
            }),
        setAuthed: () => set({ status: 'authed' }),
        setGuest: () => set({ accountCount: 0, status: 'guest' }),
    }))
)
